<!-- 
    Router-Outlet is an Angular directive to from the `Router` Library that 
    is used to insert the component matched by routes (defined in 
    app-routing.module.ts) to be displayed on the screen. See the Angular
    Router docs (https://angular.io/guide/router) for more info.
-->
<router-outlet></router-outlet>
